<template>
    <Select2 v-model="value_model" :options="profiles" :id="id" :settings="{width: '100%'}" :disabled="isLoading"/>
</template>

<script>
export default {
    name: "ProfileSelect",
    props: ['value', 'request_id', 'id', 'show_full_name'],
    data: () => ({
        value_model: null,
        isLoading: false,
        profiles: [],
    }),
    mounted() {
        let self = this;
        this.isLoading = true;
        this.value_model = this.value;
        axios.get('/api/requests/' + this.request_id + '/profiles')
            .then(r => {
                self.profiles = r.data.map(l => ({id: l.id, text: (this.show_full_name ? ' ' + [l.data.last_name, l.data.first_name, l.data.middle_name].join(' ') + ' ' : '') + l.data.title}));
                if (!self.value_model && self.profiles.length && self.profiles[0] !== undefined) self.value_model = self.profiles[0].id;
                self.isLoading = false;
            });
    },
    watch: {
        value(v) {
          this.value_model = v;
        },
        value_model(val) {
            this.$emit('input', val);
        }
    }
}
</script>

<style scoped>

</style>
